import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class MobileHybridPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: ['xamarin','kotlin','react native'], andSearch: false, search: [], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Hybrid App Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>Since 2009 I have been concentrating on complex apps for iOS and Android including many network (wifi, bluetooth and 3g/4g) attached apps. I have developed mobile apps for national TV Networks, Social Media sites and in vehicle tracking/navigation, scientific and machine control/instrumentation applications.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have combined my extensive C# and mobile experience by developing multiple hybrid/cross-platform apps in Xamarin.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I started utilizing Kotlin for much of my new android development starting in 2017. In fact, I have served as a tester for Kotlin/Native for iOS and have begun to explore hybrid/cross-platform development for Android and iOS using Kotlin in combination with native UI development in variations MVC/MVVM/MVP patterns.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I also have React Native experience.</p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Hybrid Mobile projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default MobileHybridPlatform



// WEBPACK FOOTER //
// src/Platforms/MobileHybridPlatform.js